import { Button, Typography, Box, Stack, Alert, Card, CardContent } from '@mui/material'
import { ReactComponent as People } from '@assets/images/icon/ico_people_32.svg'
import { ReactComponent as Institution } from '@assets/images/icon/ico_institution.svg'
import { useIsMobile } from '@/hooks/Responsive'

export default function Step0({ onNext, MemberType }) {
  const { isMobile } = useIsMobile()

  return (
    <Box>
      <Typography component="h3" variant={isMobile ? 'h6' : 'h5'} sx={{ mb: 1.5 }}>
        OpenVLab에 오신 것을 환영합니다.
      </Typography>
      <Typography component="p" variant={isMobile ? 'body1' : 'subtitle2'} fontWeight={400} sx={{ mb: isMobile ? 4 : 6 }}>
        일반학습자 또는 기관학습자 중 본인에게 해당하는 유형을 선택해 주세요.
      </Typography>

      <Stack
        direction={isMobile ? 'column' : 'row'}
        spacing={3}
        sx={{ mb: 1.5 }}
      >

        {/* 일반학습자 */}
        <Card
          variant="outlined"
          sx={{
            flex: 1,
            borderRadius: 3,
          }}
        >
          <CardContent
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              p: 3,
              minHeight: '136px',
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Box component={People} />
              <Typography variant="subtitle2" fontWeight={500}>
                일반학습자
              </Typography>
            </Stack>

            <Button
              variant="contained"
              color="primary"
              onClick={() => onNext(MemberType.GNRL)}
            >
              가입하기
            </Button>
          </CardContent>
        </Card>

        {/* 기관학습자 */}
        <Card
          variant="outlined"
          sx={{
            flex: 1,
            borderRadius: 3,
          }}
        >
          <CardContent
            sx={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              minHeight: '136px',
              p: 3,
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Box component={Institution} />
              <Typography variant="subtitle2" fontWeight={500}>
                기관학습자
              </Typography>
            </Stack>

            <Button
              variant="contained"
              color="primary"
              onClick={() => onNext(MemberType.INST)}
            >
              가입하기
            </Button>
          </CardContent>
        </Card>

      </Stack>

      <Alert severity="info">
        기관(학교) 정보 등록이 필요한 경우, [기관학습자]로 가입해 주세요.
      </Alert>
    </Box>
  )
}